/*
 * Alphanna — corrige o estado "scrolled" do header quando a página abre a meio.
 *
 * Bug do Aurora (medido em Chrome headless no live, 12/09/2026)
 * ---------------------------------------------------------------
 * O <header-component> calcula, no handleResize (inicialização e cada resize):
 *
 *     this.headerSectionBottom = rect.top + window.scrollY;
 *
 * e depois marca `scrolled` quando `scrollY > headerSectionBottom`.
 *
 * Com a página aberta no topo isto dá 64 (a altura da barra de anúncio) e está
 * certo. Mas se a página abre já com scroll — recarregar, voltar atrás, link
 * com âncora — ou se a janela é redimensionada a meio, o header sticky está
 * colado e o valor fica inflacionado pelo scroll. Medido no live:
 *
 *     aberta no topo : headerSectionBottom = 64    -> correcto
 *     aberta a 1292px: headerSectionBottom = 1356  -> scrolled fica false
 *
 * Com 1356 de referência, a página a 1292 nunca passa a "scrolled": o header
 * fica transparente, links e logótipo brancos por cima de conteúdo claro,
 * mesmo a rolar para cima ou uns pixéis para baixo.
 *
 * Correcção
 * ---------
 * A posição natural do header é a soma das alturas das secções que o precedem
 * no documento (a barra de anúncio). Esse valor não depende do scroll: dá 64
 * nos dois cenários. Quando a referência do tema está acima disso, reponho-a e
 * peço ao próprio componente para reavaliar (setScrollStatus). Quem aplica
 * classes e cores continua a ser o tema.
 *
 * Primeira tentativa (descartada): disparar eventos de scroll. Não resolve,
 * porque o handler volta a comparar com a mesma referência inflacionada.
 */
(function () {
  'use strict';

  function naturalTop(section) {
    var total = 0;
    for (var el = section.previousElementSibling; el; el = el.previousElementSibling) {
      if (el.classList && el.classList.contains('shopify-section')) {
        total += el.offsetHeight;
      }
    }
    return total;
  }

  function fixBaseline() {
    var hc = document.querySelector('header-component');
    if (!hc || !hc.section || typeof hc.setScrollStatus !== 'function') return;
    if (typeof hc.headerSectionBottom !== 'number') return;

    var natural = naturalTop(hc.section);
    if (hc.headerSectionBottom > natural + 1) {
      hc.headerSectionBottom = natural;
      hc.setScrollStatus();
    }
  }

  /* O handleResize do tema tem debounce de 100ms: correr depois dele. */
  function scheduleFix() {
    [250, 800].forEach(function (ms) { setTimeout(fixBaseline, ms); });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-component').then(scheduleFix);
  }
  window.addEventListener('load', scheduleFix);

  /* Cada resize volta a inflacionar a referência. */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fixBaseline, 300);
  });

  /* Voltar atrás com bfcache: a página regressa a meio sem reinicializar. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleFix();
  });
})();
